import {defineMessages} from "react-intl";

export default defineMessages({
    exportReport: { id: "traffic.exportReport", defaultMessage: "Export Report", description: 'traffic: Export Report' },
    dateFrom: {id: "traffic.cdrFilters.dateFrom", defaultMessage: "Date from", description: 'Traffic, CDRFilters: Date from'},
    groupBy: { id: "traffic.groupBy", defaultMessage: "Group by", description: 'traffic: Group by' },
    trafficStat: { id: "traffic.trafficStat", defaultMessage: "Traffic stat", description: 'Traffic: Traffic stat' },
    cdr: { id: "traffic.cdr", defaultMessage: "CDR", description: 'Traffic: CDR' },
})